export default {
  setSeatListsMutation(state,playload){

    state.seatLists = playload.seatLists;

  }
};